import { useTranslation } from 'react-i18next';

const MARKETING_BASE = (
  (import.meta.env.VITE_MARKETING_SITE_URL as string | undefined) ?? ''
).replace(/\/$/, '');

export function AppFooterWithLanguage() {
  const { t, i18n } = useTranslation();
  const prefix = i18n.language.startsWith('de') ? '/de' : '';
  const link = (page: string) => `${MARKETING_BASE}${prefix}/${page}/`;

  return (
    <footer className="mc-footer">
      <span>{t('app.footer.copyright')}</span>
      <nav className="mc-footer__links" aria-label="Legal">
        <a href={link('terms')}>{t('app.footer.terms')}</a>
        <a href={link('privacy')}>{t('app.footer.privacy')}</a>
        <a href={link('impressum')}>{t('app.footer.impressum')}</a>
        <a href={link('contact')}>{t('app.footer.contact')}</a>
      </nav>
    </footer>
  );
}
